"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportRequestState = exports.ExportDesignProvider = exports.ExportDataProvider = exports.ExportType = void 0;
var ExportType;
(function (ExportType) {
    ExportType["DOCX"] = "DOCX";
    ExportType["XLSX"] = "XLSX";
    ExportType["PDF"] = "PDF";
    ExportType["HTML"] = "HTML";
    ExportType["XML"] = "XML";
    ExportType["CSV"] = "CSV";
})(ExportType = exports.ExportType || (exports.ExportType = {}));
var ExportDataProvider;
(function (ExportDataProvider) {
    ExportDataProvider["CONFIGURATION_PROVIDER"] = "CONFIGURATION_PROVIDER";
    ExportDataProvider["NOOP_PROVIDER"] = "NOOP_PROVIDER";
    ExportDataProvider["PARAMS_PROVIDER"] = "PARAMS_PROVIDER";
    ExportDataProvider["REPORTING_PROVIDER"] = "REPORTING_PROVIDER";
    ExportDataProvider["SINGLE_ENTITY_PROVIDER"] = "SINGLE_ENTITY_PROVIDER";
})(ExportDataProvider = exports.ExportDataProvider || (exports.ExportDataProvider = {}));
var ExportDesignProvider;
(function (ExportDesignProvider) {
    ExportDesignProvider["DYNAMIC_PROVIDER"] = "DYNAMIC_PROVIDER";
    ExportDesignProvider["SIMPLE_PROVIDER"] = "SIMPLE_PROVIDER";
})(ExportDesignProvider = exports.ExportDesignProvider || (exports.ExportDesignProvider = {}));
var ExportRequestState;
(function (ExportRequestState) {
    /**
     * State of a export request after creation
     */
    ExportRequestState["PENDING"] = "PENDING";
    /**
     * State of a export request being processed
     */
    ExportRequestState["PROCESSING"] = "PROCESSING";
    /**
     * State of a request successfully processed and corresponding export file was generated
     */
    ExportRequestState["PROCESSED"] = "PROCESSED";
    /**
     * State of a export request whose processing failed
     */
    ExportRequestState["FAILED"] = "FAILED";
})(ExportRequestState = exports.ExportRequestState || (exports.ExportRequestState = {}));
//# sourceMappingURL=export-types.js.map